/** Part of the day for a greeting: 'morning' | 'afternoon' | 'evening' | 'night'. */
export const getGreetingKey = (hour) => {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  if (hour >= 18 && hour < 22) return 'evening';
  return 'night';
};

const TURKISH_GREETINGS = {
  morning: 'Günaydın',
  afternoon: 'İyi günler',
  evening: 'İyi akşamlar',
  night: 'İyi geceler',
};

/**
 * Turkish time-of-day greeting ("Günaydın", ...). Translated screens use
 * getGreetingKey with t(`common.greeting.${key}`) instead.
 */
export const getGreeting = (hour) => TURKISH_GREETINGS[getGreetingKey(hour)];
